import { lazy, Suspense, useEffect } from "react";
import Banner from "../components/Banner";

const Faq = lazy(() => import("../components/Faq.js"));
const Privileges = lazy(() => import("../components/Privileges.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  useEffect(() => {}, []);

  // Gtags
  // useEffect(() => {
  //   // Initialize if already loaded, else wait for it
  //   if (window.gtag) {
  //     window.gtag("config", "AW-848956189");
  //     window.gtag("config", "AW-961178487");
  //   }
  // }, []);

  //FB tag
  // useEffect(() => {
  //   const firePageView = () => {
  //     if (window.fbq) {
  //       window.fbq("track", "PageView");
  //       window.fbq("track", "Company-LP-1-Jan-25New");
  //     } else {
  //       setTimeout(firePageView, 300);
  //     }
  //   };

  //   firePageView();
  // }, []);

  //invmedia
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
  //   script.async = true;
  //   document.head.appendChild(script);

  //   // Initialize gtag after script loads
  //   script.onload = () => {
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag() {
  //       window.dataLayer.push(arguments);
  //     }
  //     window.gtag = gtag; // make globally available
  //     gtag("js", new Date());
  //     gtag("config", "DC-8971752");
  //     gtag("event", "conversion", {
  //       allow_custom_scripts: true,
  //       send_to: "DC-8971752/invmedia/icici02k+standard",
  //     });
  //   };
  // }, []);

  //Gtag
  // useEffect(() => {
  //   // Inject gtag.js only once
  //   if (!document.getElementById("gtag-js")) {
  //     const script = document.createElement("script");
  //     script.id = "gtag-js";
  //     script.async = true;
  //     script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661"; // only one is needed
  //     document.head.appendChild(script);
  //   }

  //   const initGtag = () => {
  //     window.dataLayer = window.dataLayer || [];

  //     function gtag() {
  //       window.dataLayer.push(arguments);
  //     }

  //     window.gtag = gtag;

  //     // Initialize gtag with both Ads tracking IDs
  //     gtag("js", new Date());
  //     window.gtag("config", "AW-818835661");
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-818835661/YG31CI3JvooaEM3huYYD",
  //     });
  //   };

    // Initialize if already loaded, else wait for it
  //   if (window.gtag) {
  //     window.gtag("config", "AW-818835661");
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-818835661/YG31CI3JvooaEM3huYYD",
  //     });
  //   } else {
  //     const existingScript = document.getElementById("gtag-js");
  //     existingScript?.addEventListener("load", initGtag);
  //   }
  // }, []);

  //bing tag
  // useEffect(() => {
  //   // Initialize UET queue if not already
  //   window.uetq = window.uetq || [];

  //   // Create the Bing UET script
  //   const script = document.createElement("script");
  //   script.src = "//bat.bing.com/bat.js";
  //   script.async = true;

  //   script.onload = script.onreadystatechange = function () {
  //     const rs = this.readyState;
  //     if (!rs || rs === "loaded" || rs === "complete") {
  //       const o = {
  //         ti: "97123908",
  //         enableAutoSpaTracking: true,
  //       };
  //       o.q = window.uetq;
  //       window.uetq = new window.UET(o);
  //       window.uetq.push("pageLoad");

  //       script.onload = script.onreadystatechange = null;
  //     }
  //   };

  //   const firstScript = document.getElementsByTagName("script")[0];
  //   if (firstScript && firstScript.parentNode) {
  //     firstScript.parentNode.insertBefore(script, firstScript);
  //   }

  //   // Optional cleanup
  //   return () => {
  //     if (script.parentNode) {
  //       script.parentNode.removeChild(script);
  //     }
  //   };
  // }, []);

  //-----------LinkedIn tag-----------
  // useEffect(() => {
  //   // Set LinkedIn Partner ID
  //   window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  //   window._linkedin_data_partner_ids.push("7810465");

  //   // Create script tag for LinkedIn insight.min.js
  //   const script = document.createElement("script");
  //   script.type = "text/javascript";
  //   script.async = true;
  //   script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

  //   const firstScript = document.getElementsByTagName("script")[0];
  //   if (firstScript && firstScript.parentNode) {
  //     firstScript.parentNode.insertBefore(script, firstScript);
  //   }

  //   // Optional: Clean up the script on unmount
  //   return () => {
  //     if (script.parentNode) {
  //       script.parentNode.removeChild(script);
  //     }
  //   };
  // }, []);

  //-----------clarity-----------
  // useEffect(() => {
  //   (function (c, l, a, r, i, t, y) {
  //     c[a] =
  //       c[a] ||
  //       function () {
  //         (c[a].q = c[a].q || []).push(arguments);
  //       };
  //     t = l.createElement(r);
  //     t.async = 1;
  //     t.src = "https://www.clarity.ms/tag/" + i;
  //     y = l.getElementsByTagName(r)[0];
  //     y.parentNode.insertBefore(t, y);
  //   })(window, document, "clarity", "script", "tjdbdkmflc");
  // }, []);

  return (
    <>
      <Suspense fallback={<>Loading...</>}>
        <Banner />
        <Privileges />
        <Faq />
        <Footer />
      </Suspense>
    </>
  );
}

export default Homepage;
